
/* Audio46: accessible focus for Store Hours, Email Us and Spanish modals. */
(function ($) {
  'use strict';
  if (!$) return;

  var selector = '#hours, #EmailUs, #Espanol';
  var activeDialog = null;
  var returnFocus = null;

    // Remember the exact link that opened the popup.
    // Capture phase runs before jQuery Modal's click handler.
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest &&
        event.target.closest('a[rel="modal:open"]');

    if (!trigger) return;

    var href = trigger.getAttribute('href');

    if (
        href === '#hours' ||
        href === '#EmailUs' ||
        href === '#Espanol'
    ) {
        returnFocus = trigger;
    }
    }, true);

  var focusableSelector = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'input:not([disabled]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    '[tabindex="0"]'
  ].join(',');

  function focus(element) {
    if (!element || !element.isConnected) return;
    try {
      element.focus({ preventScroll: true });
    } catch (err) {
      element.focus();
    }
  }

  function focusableElements(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll(focusableSelector),
      function (element) {
        return element.getClientRects().length > 0 &&
          window.getComputedStyle(element).visibility !== 'hidden';
      }
    );
  }

  // Handle each popup when jQuery Modal finishes opening it.
  $(document).on('modal:open.a46A11y', selector, function (event, modal) {
    if (event.target !== this) return;

    activeDialog = this;
// returnFocus was captured from the original opening link.

    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    this.setAttribute('tabindex', '-1');

    if (this.id === 'hours') {
      var heading = this.querySelector('.custom-heading-level3');

      if (heading) {
        heading.id = heading.id || 'a46-hours-modal-title';
        this.setAttribute('aria-labelledby', heading.id);
      } else {
        this.setAttribute('aria-label', 'Store hours');
      }
    } else if (this.id === 'EmailUs') {
      this.setAttribute('aria-label', 'Email Audio46');
    } else if (this.id === 'Espanol') {
      this.setAttribute(
        'aria-label',
        'Contacto por correo electrónico en español'
      );
    }

    focus(this);
  });

  // Restore focus to the link that opened the popup.
    $(document).on('modal:after-close.a46A11y', selector, function (event) {
    if (event.target !== this || activeDialog !== this) return;

    activeDialog = null;

    var target = returnFocus;
    returnFocus = null;

    // Allow jQuery Modal to finish its closing cleanup.
    window.setTimeout(function () {
        if (target && target.isConnected) {
        target.focus();
        }
    }, 0);
    });

  // Keep keyboard navigation inside the currently open popup.
  document.addEventListener('keydown', function (event) {
    if (!activeDialog || event.key !== 'Tab') return;

    var items = focusableElements(activeDialog);

    if (!items.length) {
      event.preventDefault();
      focus(activeDialog);
      return;
    }

    var first = items[0];
    var last = items[items.length - 1];
    var current = document.activeElement;

    if (current === activeDialog || !activeDialog.contains(current)) {
      event.preventDefault();
      focus(event.shiftKey ? last : first);
    } else if (event.shiftKey && current === first) {
      event.preventDefault();
      focus(last);
    } else if (!event.shiftKey && current === last) {
      event.preventDefault();
      focus(first);
    }
  }, true);

  // Prevent focus from escaping the popup through other scripts.
  document.addEventListener('focusin', function (event) {
    if (
      activeDialog &&
      event.target !== activeDialog &&
      !activeDialog.contains(event.target)
    ) {
      focus(activeDialog);
    }
  }, true);

})(window.jQuery);
